<template>
  <div class="container">
    <h4 class="title is-4">{{chartName}}</h4>
    <app-chart-time-frames></app-chart-time-frames>
    <div id="chartdiv"></div>
  </div>
</template>

<script>
  import moment from 'moment';
  import {mapGetters, mapMutations, mapActions} from 'vuex';
  import {beautifyObjectName} from "../utils/utils";
  /* eslint-disable */
  import * as am4core from "@amcharts/amcharts4/core";
  /* eslint-disable */
  import * as am4charts from "@amcharts/amcharts4/charts";
  /* eslint-disable */
  import am4themes_dark from "@amcharts/amcharts4/themes/dark";
  import ChartTimeFrames from '../components/ChartTimeFrames';

  export default {
    name: "screen-chart-gantt",
    components: {
      appChartTimeFrames: ChartTimeFrames
    },
    data() {
      return {
        object: null,
        currentFilters: {},
        chart: null,
        colorSet: null
      };
    },
    watch: {
      selectedTimeFrameId(value) {
        this.currentFilters['timeFrameId'] = parseInt(value);
        this.fetchEvents({
          ...this.currentFilters,
          cb: () => {
            this.chart.data = this.chartData;
          }
        });
      }
    },
    computed: {
      ...mapGetters('ui', ['loadingOverlay']),
      ...mapGetters('objects', ['objectById']),
      ...mapGetters('events', ['filters', 'events', 'selectedTimeFrameId', 'selectedTimeFrame']),
      chartName() {
        if (!this.object) {
          return 'Unknown Chart';
        }

        return beautifyObjectName(this.object.name);
      },
      chartData() {
        const ret = [];
        const firstTimestamp = parseInt(moment().format('X')) - this.selectedTimeFrame.timeStart;
        const colorForZero = this.colorSet.getIndex(0).brighten(0);
        this.events.forEach((item, idx) => {
          let colorToUse = colorForZero;
          if (parseInt(item.action_value) === 1) {
            colorToUse = this.colorSet.getIndex(10).brighten(0.9);
          }
          let toDate = moment().format('YYYY-MM-DD HH:mm');
          if (typeof this.events[idx + 1] !== "undefined") {
            toDate = moment(this.events[idx + 1].date).format('YYYY-MM-DD HH:mm');
          }
          ret.push({
            name: item.hftObjectName,
            fromDate: moment(item.date).format('YYYY-MM-DD HH:mm'),
            toDate: toDate,
            color: colorToUse,
            timestampStart: parseInt(moment(item.date).format('X'))
          });
        });
        if (ret[0].timestampStart !== firstTimestamp) {
          const item = ret[0];
          ret.unshift({
            name: item.name,
            fromDate: moment.unix(firstTimestamp).format('YYYY-MM-DD HH:mm'),
            toDate: moment(ret[0].date).format('YYYY-MM-DD HH:mm'),
            color: colorForZero,
            timestampStart: firstTimestamp
          });
        }

        return ret;
      }
    },
    methods: {
      ...mapMutations('events', ['SET_FILTERS']),
      ...mapActions('events', ['fetchEvents']),
      initChart() {
        am4core.useTheme(am4themes_dark);

        this.chart = am4core.create("chartdiv", am4charts.XYChart);
        this.chart.padding(0, 15, 0, 15);
        this.chart.dateFormatter.inputDateFormat = "yyyy-MM-dd HH:mm";
        this.chart.data = this.chartData;

        let categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "name";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.inversed = true;

        let dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.dateFormatter.dateFormat = "yyyy-MM-dd HH:mm";
        dateAxis.renderer.minGridDistance = 70;
        dateAxis.baseInterval = { count: 30, timeUnit: "minute" };
        dateAxis.max = new Date().getTime();
        dateAxis.strictMinMax = true;
        dateAxis.renderer.tooltipLocation = 0;

        let series1 = this.chart.series.push(new am4charts.ColumnSeries());
        series1.columns.template.width = am4core.percent(80);
        series1.columns.template.tooltipText = "{name}: {openDateX} - {dateX}";

        series1.dataFields.openDateX = "fromDate";
        series1.dataFields.dateX = "toDate";
        series1.dataFields.categoryY = "name";
        series1.columns.template.propertyFields.fill = "color"; // get color from data
        series1.columns.template.propertyFields.stroke = "color";
        series1.columns.template.strokeOpacity = 1;

        this.chart.scrollbarX = new am4core.Scrollbar();
      }
    },
    created() {
      this.colorSet = new am4core.ColorSet();
      this.colorSet.saturation = 0.4;
    },
    mounted() {
      const that = this;
      this.object = this.objectById(this.$route.params.objectId);
      if (this.object) {
        this.currentFilters = { ...this.filters };
        this.currentFilters['objectId'] = this.object.id;
        this.currentFilters['objectTypeId'] = this.object.object_type_id;
        this.currentFilters['orderDirection'] = 1;
        this.fetchEvents({
          ...this.currentFilters,
          cb: () => {
            that.initChart();
          }
        });
      }
    },
    destroyed() {
      am4core.disposeAllCharts();
    },
    unmounted() {
      am4core.disposeAllCharts();
    }
  }
</script>

<style scoped>
  #chartdiv {
    width: 100%;
    height: 120px;
  }
</style>